<template>
  <q-page class="app-page">
    <div class="item-line-content">
      <span :class="['check-item', { 'check-item-active': item.checked }]" v-for="(item, index) in locationList" :key="index" @click="checkLocation(index)">
        {{ item.label }}
      </span>
    </div>
    <div style="box-shadow: 0 0 0.52vw 0 rgba(0, 0, 0, 0.2);">
      <q-expansion-item
        switch-toggle-side
        v-model="expanded"
      >
      <template v-slot:header>
        <div style="font-family: blod;color: #000;font-size: 16px;display: flex;align-items: center;margin-left: -20px;">
          今日预约<label style="color:orange;">{{ reservationCount }}</label>人
        </div>
      </template>
      <q-card>
        <q-card-section>
          <ReservationInfo :collectPointId="collectPointId"></ReservationInfo>
        </q-card-section>
      </q-card>
    </q-expansion-item>
    </div>
    <div class="app-page-filters">
      <q-form ref="filtersForm" @reset="onResetFilters" @submit="onSubmintFilters">
        <div class="app-page-filters-form">
          <i-field v-model="filters.model.reservationDateStart" field-type="datetime" format="date" label="开始时间" start-of-day />
          <i-field v-model="filters.model.reservationDateEnd" field-type="datetime" format="date" label="结束时间" end-of-day />
          <i-field v-model.trim="filters.model.name" field-type="text" label="姓名" prepend-icon="person"/>
          <i-field v-model.trim="filters.model.idCard" field-type="text" label="身份证号" prepend-icon="cast"/>
          <i-field v-model.trim="filters.model.tel" field-type="text" label="手机号" prepend-icon="stay_primary_portrait"/>
          <i-field v-model="filters.model.bloodType" field-type="enum" enum="BloodType" :whiteList ="val => val.text !== '全血/成分血'" />
          <i-field v-model="filters.model.collectReturn" field-type="enum" enum="YesOrNo" label="回访状态" />
        </div>
      </q-form>
    </div>
    <div class="app-page-toolbar">
      <i-btn color="action-get" icon="search" @click="search">查询</i-btn>
      <i-btn color="action-reset" icon="undo" label="重置" tooltip-text="重置查询条件" @click="$refs.filtersForm.reset()" />
      <i-btn color="action-add" @click="exportData">导出</i-btn>
      <i-btn color="action-add" @click="importData">导入</i-btn>
      <!-- <i-btn color="action-add">发送回访短信</i-btn> -->
    </div>
    <div class="app-page-main">
      <i-table ref="main" :data="main.data" :columns="main.columns" selection="none" :pagination.sync="main.pagination"
        :loading="main.loading" @request="onMainRequest">
        <template v-slot:body-cell-operate="props">
          <q-td :props="props">
            <span class="operate-btn" @click="openDonatorInfo('result', props.row)">献血者信息</span>
            <span class="operate-btn" @click="openDonatorInfo('consult', props.row)">征询</span>
            <span class="operate-btn" @click="openDonatorInfo('result', props.row)">献血记录</span>
          </q-td>
        </template>
      </i-table>
    </div>
    <q-dialog v-model="dialogs.donatorInfo.show">
      <DonatorInfoDetail :type="dialogs.donatorInfo.type" :currentId="currentId"></DonatorInfoDetail>
    </q-dialog>
    <q-dialog v-model="dialogs.dataSet.show" persistent>
      <q-card style="width: 600px;height: 300px;">
        <q-bar style="background-color: rgb(64,149,229);color:#fff;font-weight: 700;">
          <div>{{ operateType === 'export' ? '导出预约信息' : '导入回访名单'}}</div>
          <q-space />
          <q-btn dense flat icon="close" @click="cancelDataSet">
            <q-tooltip>Close</q-tooltip>
          </q-btn>
        </q-bar>
        <q-card-section>
           <div class="export-content" v-if="operateType === 'export'">
             <div class="left">
               <img src="~@/assets/file.png" alt="">
             </div>
             <div class="right">
              <span style="font-size: 16px;font-weight: 700; color: #000;font-family: blod;margin-bottom: 10px;">导出数据包</span>
              <div class="progress-box"><q-linear-progress color="green" :value="progress" /><span style="font-size: 14px;font-family: blod;width: 50px;text-align: center;">{{progress}}</span></div>
             </div>
           </div>
           <div style="margin-top: 10px;margin-left: 70px;" v-if="operateType === 'import'">
             <a-upload
               name="file"
               :multiple="false"
               :customRequest="uploadFile"
                :file-list="fileList"
                accept=".txt"
              >
              <a-button> <a-icon type="upload" />上传文件</a-button>
             </a-upload>
           </div>
           <div  style="margin-top: 10px;" class="export-content"  v-if="operateType === 'import'">
             <div class="left">
               <img src="~@/assets/file.png" alt="">
             </div>
             <div class="right">
              <span style="font-size: 16px;font-weight: 700; color: #000;font-family: blod;margin-bottom: 10px;">导入数据包</span>
              <div class="progress-box"><q-linear-progress color="green" :value="progress" /><span style="font-size: 14px;font-family: blod;width: 50px;text-align: center;">{{progress}}</span></div>
             </div>
           </div>
        </q-card-section>
        <q-card-section>
           <div class="operate" style="display: flex;justify-content: space-around;">
            <!-- <q-btn size="md" color="white" text-color="#666" label="取消" @click="cancelDataSet"/> -->
            <q-btn size="md" style="background-color: rgb(64,149,229);color: #fff;" label="确定" @click="cancelDataSet"/>
           </div>
        </q-card-section>
      </q-card>
    </q-dialog>
  </q-page>
</template>
<script>
import utils from '@/lib/utils'
import { AppPageMixin, StoreBisAuthorizeMixin } from '@/lib/mixins'
import { BloodType, IdCardType, Sex, BloodGroup, OrderState } from '@/lib/enums'
import ReservationInfo from './ReservationInfo.vue'
import DonatorInfoDetail from './DonatorInfoDetail.vue'
export default {
  mixins: [AppPageMixin, StoreBisAuthorizeMixin],
  components: {
    ReservationInfo,
    DonatorInfoDetail
  },
  computed: {
    collectPointId () {
      return this.locationList.find(l => l.checked)?.value
    }
  },
  data () {
    return {
      fileList: [],
      operateType: '',
      progress: '0%',
      currentId: null,
      detailData: {},
      locationList: [],
      expanded: false,
      reservationCount: null,
      timeRangeDic: [],
      websocket: null,
      filters: {
        model: {
          reservationDateStart: null,
          reservationDateEnd: null,
          idCard: '',
          tel: '',
          name: '',
          bloodType: null,
          collectReturn: null,
          collectPointId: null
        }
      },
      main: {
        loading: false,
        data: [],
        columns: [
          { name: 'reservationType', label: '人员类别', format: val => val === 1 ? '线上' : (val === 2 ? '线下' : ''), sortable: false },
          { name: 'reservationDate', label: '预约日期', sortable: false },
          { name: 'timeRangeId', label: '预约时段', format: val => this.getItemText(Number(val), 'timeRangeDic'), sortable: false },
          { name: 'collectTime', label: '献血时间', format: val => utils.formatDateTime(val, 'YYYY-MM-DD HH:mm:ss'), sortable: false },
          { name: 'donNo', label: '献血编号', sortable: false },
          { name: 'bloodType', label: '采血类型', format: val => BloodType.getItemText(val), sortable: false },
          { name: 'bloodGroup', label: '血型', format: val => BloodGroup.getItemText(val), sortable: false },
          { name: 'testResult', label: '血液异常', format: val => this.testResultText(val), sortable: false },
          { name: 'resultItem', label: '异常项' },
          { name: 'name', label: '姓名', sortable: false },
          { name: 'idCardType', label: '证件类型', format: val => IdCardType.getItemText(val), sortable: false },
          { name: 'idCard', label: '证件号码', sortable: false },
          { name: 'sex', label: '性别', format: val => Sex.getItemText(val), sortable: false },
          { name: 'age', label: '年龄', sortable: false },
          { name: 'tel', label: '手机号', sortable: false },
          { name: 'state', label: '状态', format: val => OrderState.getItemText(val), sortable: false },
          { name: 'collectReturn', label: '是否回访', format: val => val === 0 ? '否' : (val === 1 ? '是' : ''), sortable: false },
          { name: 'createTime', label: '创建时间', format: val => utils.formatDateTime(val, 'YYYY-MM-DD HH:mm:ss'), sortable: false, hidden: true },
          { name: 'operate', label: '操作', sortable: false }
        ],
        pagination: {
          page: 1,
          rowsPerPage: 20,
          rowsNumber: 0,
          sortBy: 'createTime',
          descending: false
        },
        dataFilters: null
      },
      dialogs: {
        donatorInfo: {
          show: false,
          type: 'result'
        },
        dataSet: {
          show: false
        }
      }
    }
  },
  async mounted () {
    await this.getDic()
    await this.getLocation()
    this.search()
  },
  methods: {
    // 血液异常
    testResultText (val) {
      switch (val) {
        case 0:
          return '待检'
        case 1:
          return '异常'
        case 2:
          return '正常'
        default:
          return ''
      }
    },
    cancelDataSet () {
      this.dialogs.dataSet.show = false
      if (this.operateType === 'import') {
        this.search()
      }
    },
    initWebSocket () {
      const userId = this.$$user.id
      const baseUrl = this.$$webconfig.bis.websocketUrl
      this.websocket = new WebSocket(`${baseUrl}/${userId}`)
      this.websocket.onopen = this.websocketOnOpen
      this.websocket.onerror = this.websocketOnError
      this.websocket.onmessage = this.setOnMessage
      this.websocket.onclose = this.websocketClose
      // 监听窗口关闭事件，当窗口关闭时，主动去关闭websocket连接，防止连接还没断开就关闭窗口
      window.onbeforeunload = this.onbeforeunload
    },
    // 通道打开
    websocketOnOpen () {
      console.log('WebSocket连接成功')
      // this.start()
    },
    // 通道连接错误
    websocketOnError () {
      console.log('连接发生错误')
    },
    // 收到消息
    setOnMessage (event) {
      if (event.data !== '连接成功') {
        this.progress = Number(event.data) + '%'
      }
      if (event.data === '100') {
        if (this.operateType === 'export') {
          this.$q.notify('导出成功!')
        } else if (this.operateType === 'import') {
          this.$q.notify('导入完毕!')
        }
        this.websocket.close()
      }
    },
    // 通道关闭
    websocketClose () {
      this.websocket.close()
      clearTimeout(this.timeoutObj)
      clearTimeout(this.serverTimeoutObj)
      console.log('WebSocket连接关闭')
    },
    onbeforeunload () {
      this.websocket.close()
    },
    async uploadFile (file) {
      const data = file.file
      const fileParams = new FormData()
      fileParams.append('file', data)
      const result = await this.$$api.bis.post('/reservationRecords/importDonRecords/', fileParams)
      if (result.success) {
        console.log(result)
      }
    },
    exportData () {
      this.progress = '0%'
      this.operateType = 'export'
      this.initWebSocket()
      this.dialogs.dataSet.show = true
      this.downLoadFile()
    },
    async downLoadFile () {
      const params = this.filters.model
      params.collectPointId = this.collectPointId
      const result = await this.$$api.bis.request({
        methods: 'get',
        url: 'reservationRecords/exportReservations',
        params,
        responseType: 'blob'
      })
      // const result = await this.$$api.bis.get(`reservationRecords/exportReservations?collectPointId=${this.collectPointId}`)
      const blob = new Blob([result.data], { type: 'text/txt' })
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = '预约信息.txt'
      link.click()
      URL.revokeObjectURL(url)
      console.log(result)
    },
    importData () {
      this.progress = '0%'
      this.initWebSocket()
      this.operateType = 'import'
      this.dialogs.dataSet.show = true
    },
    async openDonatorInfo (type, item) {
      this.currentId = item.id
      this.dialogs.donatorInfo.type = type
      this.dialogs.donatorInfo.show = true
    },
    async getDic () {
      const rangeResult = await this.$$api.bis.get('dic/getByType?type=collect_time_range')
      this.timeRangeDic = rangeResult.data
    },
    getItemText (id, key) {
      const dic = this[key]?.find(d => d.id === id)
      return dic ? dic.text : ''
    },
    checkLocation (index) {
      this.locationList.map(l => {
        l.checked = false
      })
      this.locationList[index].checked = true
      this.reservationCount = this.locationList[index].reservationNum
      this.search()
    },
    async getLocation () {
      console.log(111111)
      const locationResult = await this.$$api.bis.get('collectPoint/pageEx?pageSize=999&pageNum=1&dataOwnerId=1&state=1')
      this.locationList = locationResult.data.data.map(item => {
        return {
          label: item.name,
          value: item.id,
          checked: false,
          reservationNum: item.reservationNum
        }
      })
      this.locationList[0].checked = true
      this.reservationCount = this.locationList[0].reservationNum
    },
    onSave () {
      this.dialogs.edit.show = false
      this.search()
    },
    getText (val) {
      const content = JSON.parse(val)
      return `${content.wifi ? 'wifi' : ''}${(content.wifi && content.food) ? '/' : ''}${content.food ? '餐食' : ''}${(content.food && content.souvenir) ? '/' : ''}${content.souvenir ? '纪念品' : ''}`
    },
    onMainRequest ({ pagination }) {
      this.search({
        filters: this.main.dataFilters,
        pagination: pagination
      })
    },
    reset () {
      utils.reset(this.filters.model)
    },
    async search (searchParams) {
      const mainParams = this.buildMainParams(searchParams)
      const query = {
        ...mainParams.filters,
        ...mainParams.page
      }
      console.log('-----', query)
      query.collectPointId = this.collectPointId
      // const result = await this.$$api.bis.get(`reservation/page?pageSize=${mainParams.page.pageSize}&pageNum=${mainParams.page.pageNum}`, mainParams)
      const result = await this.$$api.bis.request({
        methods: 'get',
        url: '/reservation/page',
        params: query
      })
      // result.notifyIfFail()
      try {
        if (result.success) {
          const resultData = result.data.data
          const pageTotal = result.data.data === undefined ? 0 : result.data.total
          result.data = {
            data: resultData,
            pageNum: mainParams.page.pageNum,
            pageTotal: pageTotal
          }
          this.updateMain(mainParams, result)
        }
      } catch (error) {
        result.data = {
          data: null,
          pageNum: mainParams.page.pageNum,
          pageTotal: 0
        }
        this.updateMain(mainParams, result)
      }
    },
    onResetFilters () {
      this.reset()
    },
    onSubmintFilters () {
      this.search()
    },
    add () {
      this.dialogs.edit = Object.assign({}, {
        show: true,
        editModel: null,
        mode: 'add'
      })
    },
    editRow (row) {
      this.dialogs.edit = Object.assign({}, {
        show: true,
        editModel: Object.assign({}, row),
        mode: 'edit'
      })
    },
    editState (row) {
      this.$q.dialog({
        message: `<span style="font-weight: 700">确认${row.state ? '停用' : '启用'}该站点吗?</span>`,
        cancel: { color: 'grey' },
        html: true,
        ok: { color: 'blue' },
        focus: 'cancel'
      }).onOk(async () => {
        const params = {
          id: row.id,
          state: Number(!row.state)
        }
        const result = await this.$$api.bis.put('/collectPoint/operate', params)
        result.notify(result.success ? '修改成功' : null)
        this.search()
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.operate-btn {
  font-family: blod;
  font-size: 14px;
  margin: 5px 10px;
  color: rgb(24,144,255);
}
.item-line-content {
  margin: 10px 0;
  .check-item {
    margin-right: 20px;
    display: inline-block;
    padding: 3px 10px;
    border: 1px solid #ccc;
    background-color: #fff;
    border-radius: 5px;
    font-family: blod;
    font-size: 14px
  }
  .check-item-active {
    background-color: #2470FF;
    color: #fff;
    border: 0
  }
  .check-item:hover {
    cursor: pointer
  }
}
.export-content {
  margin: 40px auto;
  height: 70px;
  width: 400px;
  background-color: rgba(244,245,245,0.9);
  display: flex;
  align-items: center;
  padding: 0 10px;
  .right {
    margin-left: 10px;
    margin-top: 20px;
    height: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    .progress-box {
      display: flex;
      align-items: center;
    }
  }
}
</style>
